module.exports = __webpack_public_path__ + "img/9788952750389.33129dcd.jpg";